import { useEffect, useState } from "react";

const GetReadyCountDown = ({stateChangeHandler}:{stateChangeHandler:Function}) =>{

	const initialSeconds:number = 3;
	const [seconds, setSeconds] = useState<number>(initialSeconds);
	useEffect(() =>{
		//console.log('GET READY COUNTDOWN: ' + seconds);
		let mySetTimeOut:ReturnType<typeof setTimeout> = setTimeout(()=> {
			console.log('GET READY COUNTDOWN: ' + seconds);
			if (seconds > 0) {
				setSeconds(seconds - 1);
			}
			if (seconds === 0) {
				clearInterval(mySetTimeOut);
				stateChangeHandler();
			}
			
		}, 1000);

		return ()=>{
			//clearInterval(myInterval);
		}
	}, [seconds]);
//	console.log('GET READY COUNTDOWN: ' + seconds);
	return (
		<>
			<div style={{textAlign:'center'}}>
				
				<h1 style={{color:'FireBrick'}}>
					{seconds} ...
				</h1>
			</div>
		</>
	)
}

export default GetReadyCountDown;